// extracted by mini-css-extract-plugin
export default {"main":"Main_main__+DOEQ","scoreColumnsContainer":"Main_scoreColumnsContainer__NTRT0"};